import React from 'react'
import arrow from "../Images/arrow.png"

const TableRow = ({ tableTitle }) => {
    return (
        <>
            <td scope="col" className="text-gray-900  text-sm px-2 py-2 tableborder ">
                <div>
                    <h3 className=''>{tableTitle}</h3>
                </div>
                {/* <div>
                    <img src={arrow} alt="arrow" width="15px" height="15px" />
                </div> */}
            </td>
        </>
    )
}

export default TableRow
